var _path, _path2, _g, _path3, _path4, _g2, _rect, _rect2, _g3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_39",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_39)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#6200EA"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 8L123 52H59L91 8Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_39",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 8,
    width: 64,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 8L123 52H59L91 8Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_39)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#536DFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 4,
    width: 30,
    height: 48,
    fill: "white",
    fillOpacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_39",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_39)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#1A237E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 129,
    width: 68,
    height: 22,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 133,
    width: 60,
    height: 14,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2691 85.6798C64.7216 85.8133 62.305 87.9225 61.0195 89.8332C59.5357 88.0676 56.9175 86.2223 54.3701 86.3558C48.8883 86.6431 45.5153 90.1586 45.7407 94.4598C46.0406 100.182 50.6244 103.346 55.4365 106.705C57.1523 107.853 60.441 110.849 60.8627 111.521C61.2845 112.193 63.0034 112.128 63.4425 111.386C63.8817 110.645 66.7463 107.35 68.3355 106.029C72.7674 102.186 76.9981 98.5592 76.6982 92.8374C76.4728 88.5362 72.7509 85.3925 67.2691 85.6798Z",
    fill: "#FF5353",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.63 86.3558C123.082 86.2223 120.459 88.0673 118.98 89.8332C117.689 87.9222 115.278 85.8133 112.731 85.6798C107.249 85.3925 103.527 88.5361 103.302 92.8374C103.002 98.5591 107.23 102.186 111.665 106.029C113.251 107.35 116.208 110.674 116.557 111.386C116.907 112.099 118.623 112.213 119.137 111.521C119.652 110.83 122.845 107.853 124.563 106.705C129.373 103.346 133.959 100.182 134.259 94.4598C134.485 90.1586 131.112 86.6431 125.63 86.3558Z",
    fill: "#FF5353",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot1);
export default __webpack_public_path__ + "static/media/bot-1.18a0c622e7a3bd40c90702af8536d131.svg";
export { ForwardRef as ReactComponent };